import { CaptureWithContext, Metadata } from '.'

const EVENT_CATEGORY = 'menu'
const MENU_OPENED = 'menu_opened'
const MENU_CLOSED = 'menu_closed'

export const trackMenuOpen: (
  capture: CaptureWithContext,
) => (metadata: Metadata) => void = (capture) => (metadata) =>
  capture(MENU_OPENED, {
    ...metadata,
    category: EVENT_CATEGORY,
  })

export const trackMenuClose: (
  capture: CaptureWithContext,
) => (metadata: Metadata) => void = (capture) => (metadata) =>
  capture(MENU_CLOSED, {
    ...metadata,
    category: EVENT_CATEGORY,
  })
